import React from "react";
import { Link } from "react-router-dom";
import PortalHeaderIcons from "./PortalHeaderIcons";

export default function PortalTopBar({
    sidebarToggleLabel,
    isSidebarVisible,
    onToggleSidebar,
    headerIconProps,
    userMenuOpen,
    userMenuRef,
    onToggleUserMenu,
    userAvatarColor,
    userInitial,
    userDisplayName,
    profileTo,
    onCloseUserMenu,
    onLogout,
    menuAriaLabel,
    showHeaderIcons = true,
    showProfileOption = true,
}) {
    return (
        <div className="portal-topbar-docent shadow-sm">
            <button
                type="button"
                className={`menu-panel hamburger-btn border-0 bg-transparent p-0 flex-shrink-0 text-dark ${isSidebarVisible ? 'd-md-none' : ''}`}
                onClick={onToggleSidebar}
                aria-label={sidebarToggleLabel}
                title={sidebarToggleLabel}
            >
                <i className="ri-menu-line" aria-hidden />
            </button>
            {isSidebarVisible && (
                <span aria-hidden className="portal-topbar-spacer d-none d-md-block" />
            )}

            <div className="d-flex align-items-center gap-4">
                {showHeaderIcons ? <PortalHeaderIcons {...headerIconProps} /> : null}

                <div
                    className={`user-profile-wrapper-emp portal-user-menu ${userMenuOpen ? "is-open" : ""}`}
                    ref={userMenuRef}
                >
                    <button
                        type="button"
                        className="portal-user-menu-trigger"
                        onClick={onToggleUserMenu}
                        aria-expanded={userMenuOpen}
                        aria-haspopup="menu"
                        aria-label="Abrir menu de usuario"
                    >
                        <span className="dynamic-avatar" style={{ backgroundColor: userAvatarColor }}>
                            {userInitial}
                        </span>
                        <span className="portal-user-menu-name">{userDisplayName}</span>
                        <i className={userMenuOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden />
                    </button>

                    {userMenuOpen && (
                        <ul className="portal-user-dropdown" role="menu" aria-label={menuAriaLabel}>
                            {showProfileOption ? (
                                <li role="none">
                                    <Link
                                        to={profileTo}
                                        className="portal-user-dropdown-item"
                                        role="menuitem"
                                        onClick={onCloseUserMenu}
                                    >
                                        <i className="ri-checkbox-blank-circle-line" aria-hidden />
                                        <span>Perfil</span>
                                    </Link>
                                </li>
                            ) : null}
                            <li role="none">
                                <button
                                    type="button"
                                    className="portal-user-dropdown-item"
                                    role="menuitem"
                                    onClick={onLogout}
                                >
                                    <i className="ri-checkbox-blank-circle-line" aria-hidden />
                                    <span>Cerrar sesión</span>
                                </button>
                            </li>
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}
